module.exports = __webpack_public_path__ + "static/media/b1.5a844335.jpg";